import React, { useState, useEffect, useContext } from 'react';
import { IoCloseSharp } from "react-icons/io5";
import { motion } from 'framer-motion';
import ButtonWhite from '../../button/ButtonWhite';
import ButtonBack from '../../button/ButtonBack';
import ModalAlert from '../ModalAlert'
import SingleQR from "../../layouts/home/depositar/SingleQR";
import axios from 'axios';


import { formatMontoCop } from '../../../utils/FormatBalanceCop'
import { formatCurrency } from '../../../utils/FormatCurrency'



import SelectWallet from '../../layouts/home/depositar/SelectWallet';
import SelectBuyColurs from '../../layouts/home/depositar/SelectBuyColurs';
import DepositarPSE from '../../layouts/home/depositar/DepositarPSE'
import MultiQr from '../../layouts/home/depositar/MultiQr'
import BanckTransfert from '../../layouts/home/depositar/TransfertBanck'
import { AuthContext } from '../../../context/AuthContext';
import moment from 'moment';
import { getHashKey } from '../../../functions/createSignImages';

import { ReactComponent as Check } from '../../../assets/IconsColurs/IconsGeneral/checkFilled.svg'



import Cop from '../../../assets/currency/copu.png';
import Usd from '../../../assets/currency/usd.png';
import { UtilContext } from '../../../context/UtilContext';



const ModalReceibe = ({
    activeDepositar,
    balanceCop,
    balanceUsd,
    setActiveDepositar,
    balanceWalletCop,
    balanceWalletUsd,
    WalletBalanceHome,
}) => {
    const { getAuthenticatedHeaders, } = useContext(AuthContext);
    const { longitude, latitude, IP } = useContext(UtilContext);


    const [paso, setPaso] = useState(3);
    const [walletCop, setWalletCop] = useState(true);
    const [buttonActive, setButtonActive] = useState(false)
    const [bank, setBank] = useState(null)
    const { DetailUser } = useContext(AuthContext);

    const [listCountry, setListCountry] = useState([])
    const [currencyList, setCurrencyList] = useState([

        {
            code: "COP",
            name: "COP"
        },
        {
            code: "USD",
            name: "USD"
        }
    ])



    const [listDocument, setListDocument] = useState([])
    const [listBanck, setListBanck] = useState([])
    const [BankList, setBankList] = useState([])

    /* transferencia PSE */

    const [country, setCountry] = useState("+57")
    const [document, setDocument] = useState("CC")

    const [montoPSE, setMontoPSE] = useState(null)
    const [correo, setCorreo] = useState('')
    const [phone, setPhone] = useState('')
    const [numDocument, setNumDocument] = useState('')

    const [montoPSError, setMontoPSEError] = useState(false)
    const [correoError, setCorreoError] = useState(false)
    const [correoValid, setCorreoValid] = useState(false)
    const [phoneError, setPhoneError] = useState(false)
    const [numDocumentError, setNumDocumentError] = useState(false)

    const [banckErroPSE, setBackErrorPSE] = useState(false)

    const [resumen, setResumen] = useState(false)
    const [isVisible, setIsVisible] = useState(false);
    const [finalTransactionPSE, setFinalTransactionPSE] = useState(false)
    const [alertFinistTransfert, setAlertFinistTransfert] = useState(false)

    const [errorMessagePSE, setErrorMessagePSE] = useState('')

    useEffect(() => {
        // Actualiza el estado de error solo cuando `correoValid` cambia
        setCorreoError(!correoValid);
    }, [correoValid]);


    /* varibles compra PSE */

    const [montoCompra, setMontoCompra] = useState('')
    const [comisionCompra, setComisionCompra] = useState('')
    const [ivaCompra, setIvaCompra] = useState('')
    const [totalCompra, setTotalCompra] = useState('')

    /* Transferencia bancaria */
    const [voucherBanck, setVoucherBanck] = useState(false)
    const [closeTransfert, setCloseTransfert] = useState(false)
    const [finishTransfert, setFinishTransfert] = useState(false)

    const [banck, setBack] = useState('')

    const [loading, setLoading] = useState(false)
    const [loadingBank, setLoadingBank] = useState(false)

    const [currency, setCurrency] = useState('')
    const [montoTransfert, setMontoTransfert] = useState('')
    const [evidencia, setEvidencia] = useState(null)
    const [banckArray, setBanckArray] = useState([])

    const [banckError, setBackError] = useState(false)
    const [currencyError, setCurrencyError] = useState(false)
    const [montoTransfertError, setMontoTransfertError] = useState(false)
    const [evidenciaError, setEvidenciaError] = useState(false)

    const [selectBanck, setSelectBanck] = useState(false)
    const [selectBanckError, setSelectBanckError] = useState(false)


    const [errorMessage, setErrorMessage] = useState('')
    const [errorMessageBank, setErrorMessageBank] = useState('')


    const [listCurrency, setListCurrency] = useState([])
    const [transitionBack, setTransitionBack] = useState(false)

    const [loadingAddressQr, setLoadingAddressQr] = useState(false)
    const [addressQrUSDC, setAddressQrUSDC] = useState('')
    const [addressQrUSDT, setAddressQrUSDT] = useState('')
    const [loadingResumenPSE, setLoadingResumenPSE] = useState(false)

    let phonePSE = country + phone

    const closeModalTransfert = () => {

        setVoucherBanck(false)
        setFinishTransfert(false)
        setActiveDepositar(false);
        setBack('')
        setCurrency('')
        setMontoTransfert('')
        setEvidencia(null)
        setButtonActive(false)

        setBank(null)
        setSelectBanck(false)
        setCloseTransfert(false)
        setPaso(3)
    }

    const OnClose = () => {

        if (banck !== '' || currency !== '' || montoTransfert !== '' || evidencia !== null) {

            setCloseTransfert(true)
            return
        }
        setCorreoError(false)
        setPhoneError(false)
        setNumDocumentError(false)
        setMontoPSEError(false)
        setBanckArray([])
        setErrorMessage('')
        setSelectBanckError(false)
        setErrorMessageBank(false)
        setBackError(false)
        setCurrencyError(false)
        setMontoTransfertError(false)
        setEvidenciaError(false)
        setMontoPSE('')
        setCorreo('')
        setNumDocument('')
        setPhone('')



        setVoucherBanck(false)
        setFinishTransfert(false)
        setActiveDepositar(false);
        setBack('')
        setCurrency('')
        setMontoTransfert('')
        setEvidencia(null)
        setButtonActive(false)

        setBank(null)
        setSelectBanck(false)
        setIsVisible(false)
        setPaso(3)
    };






    const NextPaso = () => {


        /* validacion de errores paso 6 */
        if (paso === 6 && voucherBanck === true && banck === '') {
            setBackError(true)
        }
        if (paso === 6 && voucherBanck === true && currency === '') {
            setCurrencyError(true)
        }
        if (paso === 6 && voucherBanck === true && montoTransfert === '') {
            setMontoTransfertError(true)
        }
        if (paso === 6 && voucherBanck === true && evidencia === null) {
            setEvidenciaError(true)
        }

        /* validacion de seleccionar un banco */
        if (!selectBanck) {

            setSelectBanckError(true)
            setErrorMessageBank('Debe escoger un banco para seguir con el proceso')
            return
        } else {
            setVoucherBanck(true)

        }

        /* validacion de errores paso 4 */
        if (correo === '') {
            setCorreoError(true)
        }
        if (phone === '') {
            setPhoneError(true)
        }
        if (numDocument === '') {
            setNumDocumentError(true)
        }
        if (montoPSE === '') {
            setMontoPSEError(true)
        }

        /* finaliza la transaccion de PSE */
        if (correo !== '' && phone !== '' && numDocument !== '' && montoPSE !== '') {
            setFinalTransactionPSE(true)
        } else {
            setResumen(false);
        }
        setMontoPSEError(false)
        setCorreoError(false)
        setNumDocumentError(false)
        setPhoneError(false)
    }

    const OnclosePrevPSE = () => {


        setButtonActive(false)
        setMontoPSE('')
        setCorreo('')
        setNumDocument('')
        setPhone('')
        setFinalTransactionPSE(false)
        setActiveDepositar(false)

        setPaso(3)

    }

    const OnclosePrevBanck = () => {
        setVoucherBanck(false)
        setFinishTransfert(false)
        setActiveDepositar(false);
        setBack('')
        setCurrency('')
        setMontoTransfert('')
        setEvidencia(null)
        setButtonActive(false)

        setBank(null)
        setSelectBanck(false)
        setPaso(3)
    }

    const BackTransfert = () => {
        setTransitionBack(false)
        if (paso === 6 && voucherBanck === true) {
            setVoucherBanck(false)
            setTransitionBack(true)
            setBackError(false)
            setCurrencyError(false)
            setMontoTransfertError(false)
            setEvidenciaError(false)
            setErrorMessage('')
            setBack('')
            setCurrency('')
            setMontoTransfert('')
            setEvidencia(null)
            return
        }

        if (paso <= 4) {

            setButtonActive(false)
            setMontoPSE('')
            setCorreo('')
            setNumDocument('')
            setPhone('')
            setPaso(2)
            setCorreoError(false)
            setPhoneError(false)
            setNumDocumentError(false)
            setMontoPSEError(false)
            setTransitionBack(true)
            setBackErrorPSE(false)
            setErrorMessagePSE('')
            setIsVisible(false)
            return
        }
        if (paso === 6) {
            setSelectBanck(false)
            setSelectBanckError(false)
            setErrorMessage('')
            setPaso(2)
            setButtonActive(false)
            setTransitionBack(true)
            setBank(null)
            setTransitionBack(false)

        }
        setTransitionBack(true)
        setErrorMessage('')
        setErrorMessageBank('')
        setErrorMessagePSE('')
    }

    const ClickWalletCop = () => {
        setTransitionBack(false)
        setWalletCop(true);
        setPaso(2);
    };

    const ClickWalletUsd = () => {
        setTransitionBack(false)
        setWalletCop(false);
        setPaso(2);
    };

    const TransfertColurs = () => {
        setTransitionBack(false)
        setPaso(3);
    };

    const TransfertPSE = () => {
        setButtonActive(true)
        setTransitionBack(false)
        setPaso(4);
    };

    const TransfertUsdt = () => {

        setTransitionBack(false)
        setPaso(5);
    };

    const TransfertBanck = () => {
        setTransitionBack(false)
        setPaso(6)
        setButtonActive(true)
    }
    const getBanks = async () => {
        setLoadingBank(true)
        await axios
            .post(`/api/transfer_account`, {
                headers: await getAuthenticatedHeaders(),

            })
            .then((response) => {
                const formattedList = response.data.data.map(item => ({
                    code: item.id,  // Usa `id` como `code`
                    name: item.bank_name_display + " - " + item.account_type_display // Usa `range` como `name`
                }));
                setListBanck(formattedList)
                setBanckArray(response.data.data)
                setLoadingBank(false)
            })
            .catch((error) => {
                console.log(error)
            });
        setLoadingBank(false)
    }

    const getBanksList = async () => {

        await axios
            .post(`/api/bank_list`, {
                headers: await getAuthenticatedHeaders(),

            })
            .then((response) => {

                const formattedList = response.data?.data?.data?.map(item => ({
                    code: item.id,  // Usa `id` como `code`
                    name: item.display_name  // Usa `range` como `name`
                }));
                setBankList(formattedList)
            })
            .catch((error) => {
                console.log(error)
            });
    }
    /* consumo del flujo de Transferencia Bancarias */
    const DepositFech = async (url) => {
        setLoading(true)
        const data = {
            "reload_method": "BANK_TRANSFER",
            "currency": currency,
            "amount": montoTransfert,
            "ip": IP,
            "longitude": longitude,
            "latitude": latitude,
            "bank_id": banck,
            "target_bank_id": bank,
            "evidence": url
        }

        await axios
            .post(`/api/reload_create`, {
                headers: await getAuthenticatedHeaders(),
                data
            })
            .then((response) => {

                if (response.data.status === 201) {
                    setFinishTransfert(true)
                }
            })

            .catch((error) => {


                setLoading(false)
                console.log(error)
            });

        setLoading(false)

    }


    const ReloadEstimateFech = async (url) => {
        setLoadingResumenPSE(true)
        const data = {
            "currency": 'COP',
            "amount": ~~montoPSE,
        }
        await axios
            .post(`/api/reload_estimate`, {
                headers: await getAuthenticatedHeaders(),
                data
            })
            .then((response) => {
                setMontoCompra(response.data.data.data.colurs_payed_amount)
                setComisionCompra(response.data.data.data.colurs_fee)
                setIvaCompra(response.data.data.data.iva)
                setTotalCompra(response.data.data.data.colurs_amount)
            })
            .catch((error) => {
                setLoadingResumenPSE(false)
                console.log(error)
            });

        setLoadingResumenPSE(false)

    }






    /* consumo del flujo de PSE */
    const DepositPSEFech = async () => {


        if (montoPSE === null || montoPSE === '') {
            setMontoPSEError(true)
            setErrorMessagePSE('Debe ingresar todos los datos')

        } else {
            setMontoPSEError(false)
        }

        if (banck === '') {
            setBackErrorPSE(true)
            setErrorMessagePSE('Debe ingresar todos los datos')

        }

        if (correo === '') {
            setCorreoError(true)
            setErrorMessagePSE('Debe ingresar todos los datos')

        }
        if (numDocument === '') {
            setNumDocumentError(true)
            setErrorMessagePSE('Debe ingresar todos los datos')

        }
        if (phone === '') {
            setPhoneError(true)
            setErrorMessagePSE('Debe ingresar todos los datos')
            return
        }

        if (numDocument <= 999) {
            setNumDocumentError(true)
            setErrorMessagePSE('Debe ingresar un Numero valido')
            return
        }
        if (montoPSE <= 9999) {
            setMontoPSEError(true)
            setErrorMessagePSE('El monto minimo a recarga es de $10.000')
            return
        }
        if (correoValid === true) {
            setCorreoError(true)
            setErrorMessagePSE('Debe ingresar un correo valido')
            return
        }
        if (!phone || phone.length !== 10) {
            setPhoneError(true);
            setErrorMessagePSE('Debe ingresar un número de teléfono válido de 10 dígitos');
            return;
        }



        setLoading(true)
        const data = {
            "ip": IP,
            "latitude": latitude,
            "longitude": longitude,
            "amount": ~~montoPSE,
            "bank_id": banck,
            "currency": "COP",
            "payer_email": correo,
            "payer_phone": phonePSE,
            "payer_type_document": document,
            "payer_document": numDocument,
            "reload_method": "PSE",
        }

        await axios
            .post(`/api/reload_create`, {
                headers: await getAuthenticatedHeaders(),
                data
            })
            .then((response) => {
                const checkoutPSE = response?.data?.data?.data?.checkout;

                if (response.data.status === 201) {
                    setAlertFinistTransfert(true)
                    if (checkoutPSE) {
                        window.open(checkoutPSE, '_blank');
                        setAlertFinistTransfert(true)
                    } else {
                        console.error('Enlace de checkout no encontrado.');
                    }

                }
            })

            .catch((error) => {
                setLoading(false)
            });

        setLoading(false)
    }


    /* consumo del flujo de USDT Y USDC */

    const QrAddressFech = async () => {
        setLoadingAddressQr(true)

        await axios
            .post(`/api/address_qr`, {
                headers: await getAuthenticatedHeaders(),
                "coin": "usdc",
                "is_otc": "true",
                "wallet_type": "MAIN"
            })
            .then((response) => {
                setAddressQrUSDC(response.data.data.address)
            })
            .catch((error) => {
                setLoadingAddressQr(false)
            });

        setLoadingAddressQr(false)
    }

    const FinishTransfertPSE = () => {

        setAlertFinistTransfert(false)
        setBack('')
        setCorreo('')
        setDocument('CC')
        setNumDocument('')
        setPhone('')
        setMontoPSE('')
        setPaso(3)
        setButtonActive(false)
        setActiveDepositar(false);
    }

    const uploadFile = async (name, archivo,) => {
        setLoading(true)
        let file = archivo;

        const originalFileName = file?.name; // Por ejemplo: "Documento sin título.pdf"

        const formato = originalFileName.split('.').pop(); // Obtiene "pdf"
        let newFileName = `${name}/${moment().valueOf()}.${formato}`;

        const headers = {
            "Content-Type": "multipart/form-data",
            "x-api-key": process.env.REACT_APP_X_API_KEY_DEV,

        };


        // Generar la firma
        const sign = getHashKey('documents'); // asegúrate de que 'documents' sea el valor correcto
        let formData = new FormData();
        formData.append("file", file);
        formData.append("sign", sign);
        formData.append("file_type", "documents");
        formData.append("file_name", newFileName);


        const header = await getAuthenticatedHeaders()
        const extendedHeaders = {
            ...header, // Los encabezados que ya tienes
            'Content-Type': 'multipart/form-data', // Otro ejemplo de encabezado adicional
        };

        const jsonString = JSON.stringify(extendedHeaders);
        formData.append("header", jsonString);
        try {
            const response = await axios.post(`/upload-image`, formData,)
            if (response.data.data.result === "OK") {
                return (response.data.data.url)
            }
        } catch (error) {

            if (error.status === 413) {
                return "Archivo demasiado grande"
            } else {
                return "no se pudo subir el archivo"
            }
        }

    };



    const OnClickBack = () => {
        /*  setTransitionBack(false) */
        setTransitionBack(false)

        if (paso === 2) {
            setPaso(paso - 1)
            setTransitionBack(false)
            return
        }
        if (paso === 3) {
            setPaso(paso - 1)
            setTransitionBack(true)
            return
        }
        if (paso === 5) {
            setPaso(2)
            setTransitionBack(false)
            return
        }


    }

    const modalVariants = {
        hidden: { scale: 0, opacity: 0 },
        visible: {
            scale: 1,
            opacity: 1,
            transition: { duration: 0.5, ease: "easeOut" }
        },
        exit: {
            scale: 0.8,
            opacity: 0,
            transition: { duration: 0.5, ease: "easeInOut" }
        },
    };


    const stepVariants = {
        hidden: transitionBack ? { x: "-100%", opacity: 0 } : { x: "100%", opacity: 0 },
        visible: { x: 0, opacity: 1 },
        exit: transitionBack ? { x: "100%", opacity: 0 } : { x: "-100%", opacity: 0 },
    };

    const handleDepositar = async () => {
        setCorreoError(false)
        /* validacion de errores paso 6 */
        if (banck === '') {
            setErrorMessage('Debe completar todos los campos antes de enviar la evidencia')
            setBackError(true)
        }
        if (currency === '') {
            setErrorMessage('Debe completar todos los campos antes de enviar la evidencia')
            setCurrencyError(true)
        }
        if (montoTransfert === '') {
            setErrorMessage('Debe completar todos los campos antes de enviar la evidencia')
            setMontoTransfertError(true)
        }
        if (evidencia === null) {
            setErrorMessage('Debe completar todos los campos antes de enviar la evidencia')
            setEvidenciaError(true)
            return
        }

        /* Validacion de los montos de recargas tanto en COP como en USD */
        if (montoTransfert <= 9999) {
            setMontoTransfertError(true)
            setErrorMessage('El monto minimo de reecarga es de 10,000')
            return
        }

        const evidenciaURL = await uploadFile("evidencia_recarga", evidencia);
        DepositFech(evidenciaURL)
    }


    useEffect(() => {
        if (resumen) {
            setIsVisible(true);
        } else {
            setTimeout(() => setIsVisible(false), 900);
        }
    }, [resumen]);

    useEffect(() => {
        if (bank !== null) {
            setSelectBanck(true);
            setErrorMessageBank('')
            setSelectBanckError(false)
        }
    }, [bank]);

    useEffect(() => {
        setMontoPSEError(false)
        setNumDocumentError(false)
        setPhoneError(false)
        setErrorMessagePSE('')
        setBackErrorPSE(false)
        if (correoValid === false) {
            setCorreoError(false)
            setErrorMessagePSE('')
        }
    }, [phone, numDocument, montoPSE, correo]);

    useEffect(() => {
        if (!activeDepositar) { return }


        getBanks()
        getBanksList()

    }, [])


    console.log(banck, 'manda esto', banckError, "lo mejor");


    useEffect(() => {
        setErrorMessage('')
        setCurrencyError(false)
        setMontoTransfertError(false)
        setEvidenciaError(false)
        setBackErrorPSE(false)
        if (banck !== '') {
            setBackError(false)
        }
    }, [banck, currency, montoTransfert, evidencia,])


    useEffect(() => {
        if (!activeDepositar) { return }
        QrAddressFech()
        getBanks()
    }, [paso === 5]);

    useEffect(() => {
        if (!activeDepositar) { return }
        getBanks()
    }, [paso === 6]);


    useEffect(() => {
        if (montoPSE === '') {
            setIsVisible(false)
        }
        if (montoPSE >= 10000) {
            ReloadEstimateFech()
            setIsVisible(true)
        }
    }, [montoPSE, banck]);

    return (
        <>
            {activeDepositar && (
                <div className="fixed inset-0 flex items-center justify-center bg-[#0e0e10] bg-opacity-85 z-50">
                    <motion.div
                        className="bg-[#26262D] rounded-lg shadow-lg w-[90%] max-w-2xl h-auto flex flex-col justify-between overflow-hidden"
                        variants={modalVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        {/* Encabezado del modal */}
                        <div className="p-6">
                            <div className="w-full flex flex-row justify-between">
                                <p className="text-lg font-semibold text-white">
                                    {paso === 1
                                        ? "Depositar"
                                        : paso === 2 && walletCop
                                            ? "Depositar COP"
                                            : paso === 2 && !walletCop
                                                ? "Depositar USD"
                                                : paso === 3
                                                    ? "Recibir usando QR"
                                                    : paso === 4
                                                        ? "Depositar con PSE"
                                                        : paso === 5
                                                            ? "Depositar con USDT/USDC"
                                                            : paso === 6 && voucherBanck === false
                                                                ? "Transferencia bancaria"
                                                                : paso === 6 && voucherBanck === true
                                                                    ? "Transferencia instantánea"
                                                                    : "Depositar"}
                                </p>
                                <IoCloseSharp
                                    size={25}
                                    color={"#b7b7b9"}
                                    onClick={OnClose}
                                    className="cursor-pointer"
                                />
                            </div>
                            <div className="h-[1.5px] w-full bg-[#16161d] mt-4"></div>
                        </div>

                        {/* Contenido dinámico del modal */}
                        <div className="flex-grow px-6">



                            {(
                                <motion.div
                                    key="step3"
                                    variants={modalVariants}
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    transition={{ duration: 0.5, ease: "easeOut" }}
                                >
                                    <SingleQR centerImage={walletCop ? Cop : Usd}
                                        ID_user={DetailUser?.email}
                                        qrValue={DetailUser?.email}
                                    />

                                </motion.div>
                            )}


                        </div>

                    </motion.div>
                </div>

            )}

        </>
    );
};

export default ModalReceibe;

